import React from "react";
import { Route, Redirect } from "react-router-dom";

const isAuthenticated = () => {
  return !!localStorage.getItem("user"); // or cookie / context
};

const UserPrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

export default UserPrivateRoute;
